module.exports = __webpack_public_path__ + "static/media/german letter umlaut.b232d50b.PNG";